/* Ability Warehouse — variant picker: buttons per option value, updates price / stock / add button / URL from the product JSON */
(function () {
  'use strict';
  var box = document.querySelector('[data-variant-picker]');
  if (!box) return;
  var product;
  try { product = JSON.parse(box.querySelector('[data-vp-product]').textContent); } catch (e) { return; }
  var form = document.querySelector('form[data-calc]');
  var idInput = form && form.querySelector('input[name="id"]');
  var addBtn = form && form.querySelector('[data-add-label]');
  var priceBox = document.querySelector('.buybox .price');
  var stock = document.querySelector('.buybox .stock');
  var sticky = document.querySelector('[data-sticky-buy]');
  var stickyOpts = sticky && sticky.querySelector('[data-sticky-opts]');
  var money = function (c) { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(c / 100); };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); };

  var opts = Array.prototype.slice.call(box.querySelectorAll('[data-vp-opt]'));
  var sel = opts.map(function (o) { var on = o.querySelector('.topt__btn.is-on'); return on ? on.dataset.vpVal : ''; });

  function find(values) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i], ok = true;
      for (var j = 0; j < values.length; j++) if (v.options[j] !== values[j]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }
  function avail(values) { var v = find(values); return v && v.available; }

  function render() {
    var v = find(sel);
    opts.forEach(function (o, i) {
      var l = o.querySelector('[data-vp-sel]');
      if (l) l.textContent = sel[i];
      Array.prototype.forEach.call(o.querySelectorAll('.topt__btn'), function (b) {
        var on = b.dataset.vpVal === sel[i];
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var trial = sel.slice(); trial[i] = b.dataset.vpVal;
        b.classList.toggle('is-off', !find(trial) || !avail(trial));
      });
    });
    if (!v) return;
    box.dataset.current = v.id;
    if (idInput) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
    var tpl = box.querySelector('template[data-vp-price="' + v.id + '"]');
    if (priceBox && tpl) priceBox.outerHTML = tpl.innerHTML; priceBox = document.querySelector('.buybox .price');
    if (stock) {
      stock.className = 'stock stock--big ' + (v.available ? 'stock--in' : 'stock--out');
      stock.innerHTML = '<span class="dot"></span>' + (v.available ? 'In stock' : 'Sold out');
    }
    if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
    if (sticky) {
      var paid = tpl ? (tpl.content.querySelector('.price__now') || {}).textContent : '';
      var cents = tpl ? Math.round(parseFloat(String(paid).replace(/[^\d.]/g, '')) * 100) : 0;
      if (cents) sticky.dataset.price = cents;
      var sp = sticky.querySelector('.price');
      if (sp && tpl) { var m = document.createElement('div'); m.innerHTML = tpl.innerHTML; var np = m.querySelector('.price'); if (np) { np.classList.remove('price--large'); sp.replaceWith(np); } }
      var sb = sticky.querySelector('[data-sb-add]');
      if (sb) { sb.disabled = !v.available; if (!v.available) sb.textContent = 'Sold out'; else if (/Sold out/.test(sb.textContent)) sb.innerHTML = 'Add to cart · <span data-sb-total>' + money(cents) + '</span>'; }
      var t = sticky.querySelector('[data-sb-total]'); if (t && cents) { var q = sticky.querySelector('[data-sb-qty]'); t.textContent = money(cents * Math.max(1, parseInt(q && q.value, 10) || 1)); }
      if (stickyOpts) stickyOpts.querySelectorAll('select').forEach(function (s, i) { s.value = sel[i]; });
    }
    try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.pathname + u.search); } catch (e) {}
    document.dispatchEvent(new CustomEvent('aw:variant', { detail: v }));
  }

  box.addEventListener('click', function (e) {
    var b = e.target.closest('.topt__btn');
    if (!b) return;
    var i = opts.indexOf(b.closest('[data-vp-opt]'));
    sel[i] = b.dataset.vpVal;
    if (!find(sel)) {
      // keep the clicked value, reset the others to the first combination that exists
      for (var k = 0; k < product.variants.length; k++) if (product.variants[k].options[i] === sel[i]) { sel = product.variants[k].options.slice(); break; }
    }
    render();
  });

  /* Mirror the options as compact selects in the sticky bar */
  if (stickyOpts && !stickyOpts.children.length) {
    stickyOpts.innerHTML = product.options.map(function (name, i) {
      var vals = [];
      product.variants.forEach(function (v) { if (vals.indexOf(v.options[i]) < 0) vals.push(v.options[i]); });
      return '<label class="sticky-buy__sel"><span>' + esc(name) + '</span><select data-vp-sticky="' + i + '" aria-label="' + esc(name) + '">' +
        vals.map(function (x) { return '<option' + (x === sel[i] ? ' selected' : '') + '>' + esc(x) + '</option>'; }).join('') + '</select></label>';
    }).join('');
    stickyOpts.addEventListener('change', function (e) {
      var s = e.target.closest('[data-vp-sticky]');
      if (!s) return;
      var i = parseInt(s.dataset.vpSticky, 10);
      sel[i] = s.value;
      if (!find(sel)) for (var k = 0; k < product.variants.length; k++) if (product.variants[k].options[i] === sel[i]) { sel = product.variants[k].options.slice(); break; }
      render();
    });
  }
})();
